import slick from 'slick-carousel'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import helper from './helper'
import { CONTENT_Y_DISTANCE, constructAnimationVars } from './gsap-shared'

gsap.registerPlugin(ScrollTrigger)

const BREAKPOINTS = {
    MEDIUMS: 479,
    MEDIUM: 639,
    TABLET: 767,
    DESKTOP: 1024,
}
const autoSpeed = 5000

let carouselMain = {
    $carousel: $('.js-carousel-main'),
    carousels: [],
    carouselsWithAutoplay: [],
    scrollInterval: null,
    init: function () {
        this.storeCarousels()
        this.carouselsWithAutoplay = this.carousels.filter(
            carousel => carousel.type === 'logos'
        )

        this.carousels.map(carousel => {
            const { $carousel, uid, type } = carousel
            const carouselObject = this.getCarouselSettings(carousel)

            // Store carousel elements
            // will update them on each carousel event
            this.storeElementsUnslicked(carousel)

            // Setup events just once
            $carousel
                .on('init', (event, slick) => {
                    this.handleDotsClassname(slick, carousel)

                    if (this.getUnslickedStatus(slick)) {
                        this.storeElementsUnslicked(carousel)
                    } else {
                        this.storeElements(carousel, slick)
                    }

                    // Init ScrollTrigger only on first carousel init
                    const trigger = ScrollTrigger.getById(uid)
                    if (!trigger) {
                        this.presetElementsPosition(carousel)
                        this.initScrollTrigger(carousel)
                    }

                    // If carousel has storyline, animate it too
                    if (
                        type === 'story' &&
                        $('.js-story-line-wrap').length > 0
                    ) {
                        this.initStoryLineTrigger()
                    }

                    if (type === 'features') {
                        const firstVideoSlide = $(event.currentTarget)
                            .find('.slick-current')
                            .find('.js-features-video')

                        //Play the first video
                        firstVideoSlide.trigger('play')

                        this.attachPlayVideoEvent(slick, carousel)
                    }
                    if (type === 'slider-nav' || type === 'slider-nav-alt') {
                        // Setting the animation effect for the first slide
                        let $currentSlider = $(event.currentTarget)
                            .find('.slick-current')
                            .removeClass('slick-current')

                        setTimeout(() => {
                            $currentSlider.addClass('slick-current')
                        }, 300)
                    }
                })
                .on('breakpoint', (event, slick) => {
                    this.handleDotsClassname(slick, carousel)
                    if (this.getUnslickedStatus(slick)) {
                        this.storeElementsUnslicked(carousel)
                    } else {
                        this.storeElements(carousel, slick)
                    }
                    if (type === 'features') {
                        const currentVideo = $(event.currentTarget)
                            .find('.slick-current')
                            .find('.js-features-video')
                            .get(0)

                        currentVideo.pause()
                        currentVideo.currentTime = 0
                        this.attachPlayVideoEvent(slick, carousel)
                    }
                })

                .on('afterChange', (event, slick) => {
                    this.storeElements(carousel, slick)

                    if (type === 'process') {
                        let currentSlide = slick.$slides[slick.currentSlide]

                        //Store the index of the current slide, plus sign to convert it to a number
                        window.$ourProcessLastIndex =
                            +currentSlide.getAttribute('data-slick-index')
                    }

                    if (type === 'features') {
                        const allvideos =
                            document.querySelectorAll('.js-features-video')

                        // Pause all other videos
                        for (const video of allvideos) {
                            video.pause()
                            video.currentTime = 0
                        }

                        const currentSlide = $(event.currentTarget)
                            .find('.slick-current')
                            .find('.js-features-video')

                        // Play the video
                        if (!this.videoIsPlaying(currentSlide)) {
                            currentSlide.trigger('play')
                        }
                    }
                })
                .on('unslick', (event, slick) => {
                    this.storeElementsUnslicked(carousel)
                })

            // Init carousel
            $carousel.slick(carouselObject)
        })

        // Pause autoplay while scrolling
        $(window).on('load resize orientationchange scroll', () => {
            clearTimeout(this.scrollInterval)
            this.carouselsWithAutoplay.map(carousel => {
                carousel.$carousel.slick('slickPause')
            })
            this.scrollInterval = setTimeout(() => {
                this.carouselsWithAutoplay.map(carousel => {
                    // Plays autoplay carousels only when in the viewport
                    if (
                        helper.isElementInViewport(
                            carousel.$carousel,
                            'partialInView'
                        )
                    ) {
                        carousel.$carousel.slick('slickPlay')
                    }
                })
                // Features carousel pause/play logic
                this.carousels.map(carousel => {
                    const { type, $carousel } = carousel
                    const $featuresCarouselWrapper = $(
                        '.js-section-features-list'
                    )
                    if (
                        helper.isElementInViewport(
                            $featuresCarouselWrapper,
                            'partialInView'
                        )
                    ) {
                        if (
                            carousel.type === 'slider-nav' ||
                            carousel.type === 'slider-nav-alt'
                        ) {
                            carousel.$carousel.removeClass('carousel-paused')
                        }

                        if (carousel.type === 'features') {
                            let currVideo = carousel.$carousel
                                .find('.slick-current')
                                .find('.js-features-video')
                                .get(0)

                            if (!this.videoIsPlaying(currVideo)) {
                                currVideo.play()
                            }
                        }
                    }

                    if (
                        !helper.isElementInViewport(
                            $featuresCarouselWrapper,
                            'partialInView'
                        )
                    ) {
                        if (
                            carousel.type === 'slider-nav' ||
                            carousel.type === 'slider-nav-alt'
                        ) {
                            carousel.$carousel.addClass('carousel-paused')
                        }
                        if (carousel.type === 'features') {
                            let currVideo = carousel.$carousel
                                .find('.slick-current')
                                .find('.js-features-video')
                                .get(0)

                            if (this.videoIsPlaying(currVideo)) {
                                currVideo.pause()
                            }
                        }
                        carousel.$carousel.slick('slickPause')
                    }
                })
            }, 250)
        })

        $(document).ready(() => {
            this.carousels.map(carousel => {
                const $featuresCarouselWrapper = $('.js-section-features-list')

                if (
                    !helper.isElementInViewport(
                        $featuresCarouselWrapper,
                        'partialInView'
                    )
                ) {
                    if (
                        carousel.type === 'slider-nav' ||
                        carousel.type === 'slider-nav-alt'
                    ) {
                        carousel.$carousel.addClass('carousel-paused')
                    }
                    if (carousel.type === 'features') {
                        let currVideo = carousel.$carousel
                            .find('.slick-current')
                            .find('.js-features-video')
                            .get(0)
                        if (this.videoIsPlaying(currVideo)) {
                            currVideo.pause()
                        }
                    }
                    carousel.$carousel.slick('slickPause')
                }
            })

            // Add filters
            $('select.js-filter').on('change', () => {
                this.filterItems($('select.js-filter').val(), $('.search-term').val().trim());
            });
            $('.trigger-search').on('click', () => {
                this.filterItems($('select.js-filter').val(), $('.search-term').val().trim());
            });
            $('.search-term').on('change', () => {
                this.filterItems($('select.js-filter').val(), $('.search-term').val().trim());
            });
        })

        $('.js-slide-nav-box').on('click', event => {
            let currentPosition = $(event.target)
                .parents('.slick-slide')
                .data('slick-index')

            setTimeout(() => {
                $('.slider-features').slick('slickGoTo', currentPosition)
            }, 700)
        })

        // Reinit carousel on resize, if it has been unslicked
        $(window).on('resize orientationchange', () => {
            this.carousels.map(carousel => {
                const { type, $carousel } = carousel
                const carouselObject = this.getCarouselSettings(carousel)

                if (!$carousel.hasClass('slick-initialized')) {
                    const windowWidth = helper.getWidth()
                    const initForMobile =
                        windowWidth <= BREAKPOINTS.MEDIUM &&
                        [
                            'reviews',
                            'social',
                            'services',
                            'process',
                            'listing-mobile',
                            'cities',
                            'healthcare',
                        ].indexOf(type) >= 0
                    const initBelowDesktop =
                        windowWidth <= BREAKPOINTS.DESKTOP &&
                        ['solutions', 'listing-tbl'].indexOf(type) >= 0

                    if (initForMobile || initBelowDesktop) {
                        $carousel.slick(carouselObject)
                    }
                }
            })
        })
    },
    getUnslickedStatus: function (slick) {
        const { activeBreakpoint, breakpointSettings } = slick
        if (
            breakpointSettings &&
            breakpointSettings[activeBreakpoint] === 'unslick'
        )
            return true
        else return false
    },
    storeCarousels: function () {
        this.$carousel.map((index, carousel) => {
            const $carousel = $(carousel)
            this.carousels.push({
                uid: helper.getUid(),
                $carousel,
                $carouselClone: $carousel.clone(true, true),
                $wrapper: $carousel.closest('.carousel-controls'),
                type: $carousel.data('carousel-type'),
                activeElements: [],
                inactiveElements: [],
            })
        })
    },
    storeElements: function (carousel, slick) {
        let activeElements = []
        let inactiveElements = []

        const {
            $slides,
            options: { infinite },
        } = slick
        const { $carousel } = carousel
        const $slidesToCheck = infinite ? $('.slick-slide', $carousel) : $slides

        $slidesToCheck.map((index, slide) => {
            const $slide = $(slide)
            const $element = $slide.find('.js-gsap-slide')
            if ($element.length) {
                if (
                    $slide.hasClass('slick-active') ||
                    $slide.prev('.slick-slide').hasClass('slick-active') ||
                    $slide.next('.slick-slide').hasClass('slick-active')
                ) {
                    activeElements.push($element.get(0))
                } else {
                    inactiveElements.push($element.get(0))
                }
            }
        })

        carousel.activeElements = activeElements
        carousel.inactiveElements = inactiveElements
    },
    storeElementsUnslicked: function (carousel) {
        const { $carousel } = carousel
        const activeElements = $carousel.find('.js-gsap-slide').toArray()

        carousel.activeElements =
            activeElements.length > 0 ? activeElements : []
        carousel.inactiveElements = []
    },
    filterItems: function (filter, searchTerm) {
        let filterCarousels = this.carousels.filter(c => c.$carousel.is('.js-carousel-filter'));
        if (filterCarousels.length > 0) {
            // Show all sections
            $('.filter-section').show();

            // Filter items in every carousel
            filterCarousels.map(carousel => {
                carousel.$carousel.slick('unslick');
                carousel.$carousel.empty();

                // We need to clone items, otherwise carousel would remove items mathing current filter wehn filter is cleared
                const itemsClone = carousel.$carouselClone.clone(true, true);
                let items = itemsClone.children().filter(function (index) {
                    return (!filter || $(this).attr('data-filter') == filter)
                        && (!searchTerm || $(this).attr('data-search').toLowerCase().includes(searchTerm.toLowerCase()));
                });

                carousel.$carousel.append(items);

                const carouselObject = this.getCarouselSettings(carousel)
                carousel.$carousel.slick(carouselObject);
            });

            // Hide empty sections
            $('.filter-section').each(function () {
                let $this = $(this);
                if ($this.find('.slick-track').is(':empty')) {
                    $this.hide();
                }
            });

            // Show no results section if there is no content
            if ($('.filter-section:visible').length > 0) {
                $('.no-results-wrapper').hide();
            }
            else {
                $('.no-results-wrapper').show();
                $('.no-results-wrapper #search-term').text(searchTerm);
            }

            // Trigger resize event to update positions when content is hidden/shown
            $(window).trigger('resize');
        }
    },
    initScrollTrigger: function (carousel) {
        const { $carousel, uid } = carousel

        ScrollTrigger.create({
            id: uid,
            trigger: $carousel.get(0),
            start: 'top bottom-=90px',
            end: 'bottom 90px',
            invalidateOnRefresh: true,
            onEnter: ({ direction, isActive }) =>
                this.animateElements(carousel, direction, isActive),
            onLeave: ({ direction, isActive }) =>
                this.animateElements(carousel, direction, isActive),
            onRefresh: ({ progress }) => {
                this.refreshElementsPosition(carousel, progress)
            },
            onToggle: ({ direction, isActive }) => {
                this.animateElements(carousel, direction, isActive)
            },
        })

        ScrollTrigger.create({
            id: uid,
            trigger: $carousel.get(0),
            start: 'top bottom-=90px',
            end: 'bottom 120px',
            invalidateOnRefresh: true,
            onEnterBack: ({ direction, isActive }) =>
                this.animateElements(carousel, direction, isActive),
            onLeaveBack: ({ direction, isActive }) =>
                this.animateElements(carousel, direction, isActive),
        })
    },

    initStoryLineTrigger: function () {
        const trigger = document.querySelector('.js-story-line-wrap')
        const lines = gsap.utils.toArray('.js-story-line')

        gsap.set(lines, { y: CONTENT_Y_DISTANCE, opacity: 0 })

        ScrollTrigger.create({
            trigger: trigger,
            start: 'top bottom-=120px',
            end: 'bottom 120px',
            invalidateOnRefresh: true,
            onRefresh: ({ progress }) => {
                if (progress >= 1)
                    gsap.set(lines, {
                        y: -CONTENT_Y_DISTANCE,
                    })
            },
            onToggle: ({ direction, isActive }) =>
                gsap.to(lines, constructAnimationVars(direction, isActive)),
        })
    },
    presetElementsPosition: function (carousel) {
        const { activeElements, inactiveElements } = carousel
        if (activeElements.length > 0) {
            const allElements = activeElements.concat(inactiveElements)

            gsap.set(allElements, {
                y: CONTENT_Y_DISTANCE,
                opacity: 0,
            })
        }
    },
    refreshElementsPosition: function (carousel, progress) {
        const { activeElements, inactiveElements } = carousel

        if (activeElements.length > 0) {
            const allElements = activeElements.concat(inactiveElements)

            if (progress >= 1) {
                gsap.set(allElements, {
                    y: -CONTENT_Y_DISTANCE,
                    opacity: 0,
                })
            } else if (progress <= 0) {
                gsap.set(allElements, {
                    y: CONTENT_Y_DISTANCE,
                    opacity: 0,
                })
            }
        }
    },
    animateElements: function (carousel, direction, isActive) {
        const { activeElements, inactiveElements } = carousel

        if (activeElements.length) {
            gsap.to(
                activeElements,
                constructAnimationVars(direction, isActive, true)
            )
        }
        if (inactiveElements.length) {
            gsap.to(
                inactiveElements,
                constructAnimationVars(direction, isActive, true)
            )
        }
    },
    handleDotsClassname: function (slick, carousel) {
        const { $wrapper } = carousel
        const {
            options: { dots },
            unslicked,
        } = slick

        if (dots && !unslicked) {
            $wrapper.addClass('has-dots')
        } else {
            $wrapper.removeClass('has-dots')
        }
    },
    videoIsPlaying: function (video) {
        const isPlaying =
            video.currentTime > 0 &&
            !video.paused &&
            !video.ended &&
            video.readyState > video.HAVE_CURRENT_DATA

        return isPlaying
    },
    attachPlayVideoEvent: function (slick, carousel) {
        $('video').on('ended', function () {
            const nextSlide =
                slick.currentSlide < slick.$slides.length - 1
                    ? slick.currentSlide + 1
                    : 0
            carousel.$carousel.slick('slickGoTo', nextSlide)
        })
    },
    getCarouselSettings: function (carousel) {
        const { type, $wrapper } = carousel
        const leftArrow =
            '<span class="slick-prev"><span class="svg-use-icon carousel-arrow-left"><svg><use xlink:href="#carousel-arrow-left"></use></svg></span></span>'
        const rightArrow =
            '<span class="slick-next"><span class="svg-use-icon carousel-arrow-right"><svg><use xlink:href="#carousel-arrow-right"></use></svg></span></span>'

        // Default type: data('carousel-type') == 'single'
        const carouselObject = {
            dots: true,
            arrows: false,
            prevArrow: leftArrow,
            nextArrow: rightArrow,
            appendDots: $wrapper.find('.carousel-dots'),
            appendArrows: $wrapper,
            speed: 600,
            autoplaySpeed: autoSpeed,
            mobileFirst: true,
            infinite: false,
            slidesToScroll: 1,
            touchThreshold: 8,
            responsive: [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.MEDIUM,
                    settings: {
                        arrows: true,
                    },
                },
            ],
        }

        // Overrides by type
        if (type == 'listing') {
            carouselObject.dots = false
            carouselObject.responsive = [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.MEDIUM,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.DESKTOP,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: true,
                    },
                },
            ]
        }

        if (type == 'cities') {
            carouselObject.dots = true
            carouselObject.infinite = true
            carouselObject.responsive = [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                        dots: true,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.MEDIUM,
                    settings: 'unslick',
                },
            ]
        }

        if (type == 'listing-mobile') {
            carouselObject.responsive = [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                        dots: false,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.MEDIUM,
                    settings: 'unslick',
                },
            ]
        }

        if (type == 'listing-tbl') {
            carouselObject.responsive = [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                        dots: false,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.MEDIUM,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true,
                        dots: false,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.DESKTOP,
                    settings: 'unslick',
                },
            ]
        }

        if (type == 'listing-dots') {
            carouselObject.responsive = [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.MEDIUM,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.DESKTOP,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: true,
                    },
                },
            ]
        }

        if (type == 'story') {
            carouselObject.dots = false
            carouselObject.responsive = [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.MEDIUM,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.DESKTOP,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: true,
                    },
                },
            ]
        }

        if (type == 'logos') {
            carouselObject.autoplay = true
            carouselObject.autoplaySpeed = 3000
            carouselObject.infinite = true
            carouselObject.responsive = [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.MEDIUMS,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.MEDIUM,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.TABLET,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: true,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.DESKTOP,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        arrows: true,
                    },
                },
            ]
        }

        if (type == 'reviews') {
            carouselObject.responsive = [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.MEDIUM,
                    settings: 'unslick',
                },
            ]
        }

        if (type == 'social') {
            carouselObject.responsive = [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.MEDIUM,
                    settings: 'unslick',
                },
            ]
        }

        if (type == 'solutions') {
            carouselObject.responsive = [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.MEDIUM,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.DESKTOP,
                    settings: 'unslick',
                },
            ]
        }

        if (type == 'services') {
            carouselObject.responsive = [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.MEDIUM,
                    settings: 'unslick',
                },
            ]
        }

        if (type == 'healthcare') {
            carouselObject.responsive = [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.MEDIUM,
                    settings: 'unslick',
                },
            ]
        }

        if (type == 'news-head') {
            carouselObject.responsive = [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ]
        }

        if (type == 'features') {
            carouselObject.responsive = [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        fade: true,
                        autoplay: false,
                        pauseOnFocus: false,
                        pauseOnHover: false,
                        infinite: true,
                        asNavFor: '.slider-nav',
                    },
                },
                {
                    breakpoint: BREAKPOINTS.DESKTOP,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        fade: true,
                        autoplay: false,
                        pauseOnFocus: false,
                        pauseOnHover: false,
                        infinite: true,
                        asNavFor: '.slider-nav',
                    },
                },
            ]
        }

        if (type == 'slider-nav') {
            carouselObject.responsive = [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        pauseOnFocus: false,
                        pauseOnHover: false,
                        asNavFor: '.slider-features',
                        focusOnSelect: true,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.DESKTOP,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        pauseOnFocus: false,
                        pauseOnHover: false,
                        asNavFor: '.slider-features',
                        focusOnSelect: true,
                    },
                },
            ]
        }

        if (type == 'slider-nav-alt') {
            carouselObject.responsive = [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        pauseOnFocus: false,
                        pauseOnHover: false,
                        asNavFor: '.slider-features',
                        focusOnSelect: true,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.DESKTOP,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        pauseOnFocus: false,
                        pauseOnHover: false,
                        asNavFor: '.slider-features',
                        focusOnSelect: true,
                    },
                },
            ]
        }

        if (type == 'process') {
            carouselObject.infinite = true
            carouselObject.initialSlide = window.$ourProcessLastIndex
            carouselObject.responsive = [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                        dots: true,
                        arrows: false,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.MEDIUM,
                    settings: 'unslick',
                },
            ]
        }

        if (type == 'alternate') {
            carouselObject.responsive = [
                {
                    breakpoint: 0,
                    settings: {
                        slidesToShow: 1,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.MEDIUM,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: true,
                    },
                },
                {
                    breakpoint: BREAKPOINTS.DESKTOP,
                    settings: {
                        slidesToShow: 1,
                        arrows: true,
                    },
                },
            ]
        }

        return carouselObject
    },
}

carouselMain.init()
